module.exports = __webpack_public_path__ + "img/GP2. Croatia_greenpact.9a60bdb1.jpg";